import { render, staticRenderFns } from "./PrivacyProtocolLess.vue?vue&type=template&id=16daba4c&scoped=true"
import script from "./PrivacyProtocolLess.vue?vue&type=script&lang=js"
export * from "./PrivacyProtocolLess.vue?vue&type=script&lang=js"
import style0 from "./PrivacyProtocolLess.vue?vue&type=style&index=0&id=16daba4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16daba4c",
  null
  
)

export default component.exports